// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__25kPV","colMin":"styles_colMin__1PygY","colCheckbox":"styles_colCheckbox__2Z64K"};